import { agencyPath, createRequestWithComputedFilters } from '@/utils/api'
import network from '@/utils/network'

/**
 * Récupère les templates de contrats agents
 * @param filters
 * @param opt
 * @returns {Promise}
 */
export const fetchAgencyAgentContractsTemplates = createRequestWithComputedFilters(async (params) => {
  const r = await network.post(`${agencyPath()}/fetch/contracts/templates/agents`, params)
  return r.data
})

/**
 * Dupplique à jour un template de contrat agent
 * @returns {Promise<>}
 */
export const postAgencyAgentContractTemplate = async (agentContractTemplate) => {
  const r = await network.post(`${agencyPath()}/contract/template/agent`, agentContractTemplate)
  return r.data
}

/**
 * Supprime un template de contrat agent
 * @returns {Promise<>}
 */
export const deleteAgencyAgentContractTemplate = async (id) => {
  const r = await network.delete(`${agencyPath()}/contract/template/agent/${id}`)
  return r.data
}
